import {
  availableThcResDto,
  currentThcResDto,
  thcLimitResDto,
} from '@web/common';
import { authenticatedAPI } from '../AuthenticatedAPI';

export const getMyCurrentThc = async () => {
  return authenticatedAPI.get(`/api/participant/thc/current`, currentThcResDto);
};

export const getCurrentThcLimit = async () => {
  return authenticatedAPI.get(`/api/participant/thc/limit`, thcLimitResDto);
};

// endpoint for shop employee
export const getAvailableThcForParticipant = async (userId: string) => {
  return authenticatedAPI.get(
    `/api/participant/thc/current/${userId}`,
    availableThcResDto,
  );
};
